import { Client } from '../../client/classes/client';

export class MeineKontakteDialogInput {
    intern: boolean;
    extern: boolean;
    schlachthof: boolean;
    kunde_id_a: number;
    titel: string;

    constructor(titel: string, intern: boolean, extern: boolean, schlachthof: boolean, kunde_id: number) {
        this.intern = intern;
        this.extern = extern;
        this.kunde_id_a = kunde_id;
        this.schlachthof = schlachthof;
        this.titel = titel;
    }
}

export class MeineKontakteDialogResult {
    kunde: Client;

    constructor(kunde: Client) {
        this.kunde = kunde;
    }
}
